import { render, staticRenderFns } from "./DeferredMount.vue?vue&type=template&id=6b52e78e"
import script from "./DeferredMount.vue?vue&type=script&lang=ts"
export * from "./DeferredMount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports